import moment from 'moment'

export const STAGES = ['unbatched', 'pending_design', 'pending_embroidery', 'pending_qcht']
export const STAGE_LABELS = {
    unbatched: 'Chưa phân lô',
    pending_design: 'Chưa thiết kế',
    pending_embroidery: 'Chưa thêu',
    pending_qcht: 'Chưa QC hoàn thành',
}

// Màu không phải kênh thông tin duy nhất: mỗi mức có icon + nhãn chữ (BR-1.4)
export const TIERS = ['not_overdue', 'near_overdue', 'overdue', 'unknown']
export const TIER_META = {
    not_overdue: {label: 'Chưa quá hạn', hint: 'còn ≥ 36h', icon: 'check-circle'},
    near_overdue: {label: 'Sắp quá hạn', hint: 'còn < 36h', icon: 'warning'},
    overdue: {label: 'Quá hạn', hint: '', icon: 'close-circle'},
    unknown: {label: 'Chưa xác định hạn', hint: '', icon: 'question-circle'},
}

export const OVERDUE_STAGE_OPTIONS = [
    {value: 'pending_design', label: 'Quá hạn thiết kế (vào lô > 48h chưa thiết kế)'},
    {value: 'pending_embroidery', label: 'Quá hạn thêu (thiết kế > 12h chưa thêu)'},
    {value: 'pending_qcht', label: 'Quá hạn QCHT (thêu > 12h chưa QCHT)'},
]
export const LATE_LABELS = {pending_design: 'Trễ thiết kế', pending_embroidery: 'Trễ thêu', pending_qcht: 'Trễ QCHT'}

const EMPTY = '—'

// Định dạng số vi-VN (BR-1.5)
export const formatNumber = (n) => Number(n || 0).toLocaleString('vi-VN')

// Mốc thời gian hiển thị theo giờ Việt Nam UTC+7 (BR-4.4); chưa có giá trị → "—" (BR-4.2)
export const formatDateTime = (iso) => (iso ? moment(iso).utcOffset(7).format('HH:mm DD/MM') : EMPTY)

const decimal = (n) => n.toFixed(1).replace('.', ',')

// Làm tròn theo chiều có lợi cho người đọc: "Còn" làm tròn xuống (không báo dư thời gian), "Quá hạn" làm tròn lên (không báo thiếu)
// EPSILON tránh sai số số thực đẩy giá trị tròn (vd 12 giờ) sang đơn vị kế tiếp
const EPSILON = 1e-9
const roundBy = (value, up) => (up ? Math.ceil(value - EPSILON) : Math.floor(value + EPSILON))

// overtime tính theo ngày: dương = quá hạn, âm = còn lại. Làm tròn trước, rồi mới chọn đơn vị: < 48 giờ hiện theo giờ, còn lại theo ngày
export const formatDeadline = (item) => {
    if (item.deadline_tier === 'unknown') return 'Chưa xác định'
    const overdue = item.deadline_tier === 'overdue'
    const hours = roundBy(Math.abs(item.overtime) * 24, overdue)
    if (hours < 1) return 'Còn dưới 1 giờ'
    const amount = hours < 48 ? `${hours} giờ` : `${decimal(roundBy(hours * 10 / 24, overdue) / 10)} ngày`
    return `${overdue ? 'Quá hạn' : 'Còn'} ${amount}`
}

export const formatDesigner = (user) => {
    if (!user) return EMPTY
    return user === '3D system' ? 'Hệ thống (reuse)' : user
}

export const orNothing = (value) => value || EMPTY

export const formatBarcode = (item) => `#${item.barcode_number}_${item.item_number}`
